import React, { useEffect, useState } from "react";
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import Dashboard from '../components/provider/dashboard';
import { Center } from "@chakra-ui/react";
import AttractiveLoadingSpinner from '../components/global/Loading';


export default function DashBoard() {
  const location = useLocation();
  const { token, FullName, selectedRole } = location.state || {};
  const navigate = useNavigate();
  const [isVerified, setIsVerified] = useState(false);
  const [ticketToken, setTicketToken] = useState(" ");
  const [role, setRole] = useState(" ");

  useEffect(() => {
    // Check both location state token and localStorage token
    const storedToken = localStorage.getItem('authToken');
    const effectiveToken = token || storedToken;

    if (effectiveToken) {
      fetchData(effectiveToken);
    } else {
      console.error("No token available");
      navigate('/login'); // Redirect to login page when no token is found
    }
  }, [token, navigate]);

  const fetchData = async (token) => {
    try {
      // Store token in localStorage when making the request
      localStorage.setItem('authToken', token);
      // Get FullName from localStorage if not available in state
      const storedFullName = localStorage.getItem('fullName') || FullName;
      
      const res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/signup`,
        { 
          FullName: storedFullName, // Use stored FullName
          role: selectedRole 
        },
        { 
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          } 
        }
      );

      if (res.data.ticketToken) {
        setIsVerified(true);
        setTicketToken(res.data.ticketToken);
        setRole(res.data.UserDetails.role);
        sessionStorage.setItem('ticketToken', res.data.ticketToken);
        
        // Clear the stored FullName after successful signup
        localStorage.removeItem('fullName');
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response?.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('fullName'); // Also remove fullName on error
        navigate('/login');
      }
    }
  };


  useEffect(() => {
    if (isVerified) {
      sessionStorage.setItem('ticketToken', ticketToken);
      if (role === "individual_provider" || role === "agency_provider")  
      navigate('/provider-home');
      else if (role === "individual_applicant" || role === "agency_applicant")
      navigate('/seeker-home');
      else if (role === "admin"){
        console.log(ticketToken);
        navigate('/admin');
      }
    }
  }, [isVerified, navigate]);

  // ... existing code ...

  return (
    isVerified ? (
      <div className="App">
        <Center h="100vh">
          <AttractiveLoadingSpinner size="50px" primaryColor="#3182CE" secondaryColor="#63B3ED" />
        </Center>
      </div>
    ) : (
      <Center h="100vh">
        <AttractiveLoadingSpinner size="50px" primaryColor="#3182CE" secondaryColor="#63B3ED" />
      </Center>
    )
  );
}



    
    /*     const fetchData = async(token) =>{
        const res = await fetch('http://localhost:3000/hello',{
         method:'GET',
         headers:{
             Authorization: 'Bearer ' + token,
         },
        });
        console.log(res.data)
        //console.log("helloFromFronEndFromServer ");
     //console.log(res)
     }*/

     
    //  return (
    //   verified?(
    //     <div className="App">
    //       <Dashboard  />
    //     </div>
    //   ):(
    //     <>
    //     {alert("Verification failed! You are not allowed access.")}
    //     <div>
    //       {/* Optional: additional UI elements */}
    //     </div>
    //   </>
    //   )
    //   );
  
    

